/**
 * Geometric tolerances used when auditing HITL state for collinearity,
 * positional drift, and plausible page scale.
 */
export const StateAudit = {
	/** Minimum cosine for two segments to be treated as collinear. */
	collinearityCosMin: 0.99,
	positionTolerancePx: 2,
	lengthTolerancePx: 4,
	scaleMinMmPerPx: 0.1,
	scaleMaxMmPerPx: 100,
} as const;
